<template>
  <div>
    <LeadersListHeader
      :headerImg="headerImg"
      :text="'リストに戻る'"
      :routeUrl="`/fanClub/leaders/list/${categoryName}`"
      :showButton="true"
      :showSearch="false"
      class="header-component"
    />
    <div class="member-detail-body">
      <LeadersMemberCard
        :id="contentId"
        :thumbnailUrl="mainImageUrl"
        :categoryIconUrl="categoryIconUrl"
        :memberName="memberName"
        :prefecture="prefecture"
        :showCategoryIcon="showCategoryIcon"
        :categoryCheck="true"
      />
      <div class="member-content">
        <p v-html="content" class="html-content"></p>
      </div>
      <div>
        <img :src="sub1ImageUrl" class="sub-img" v-if="sub1ImageUrl" />
        <img :src="sub2ImageUrl" class="sub-img" v-if="sub2ImageUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import GetContent from "@/components/api/fanClub/leaders/leadersMemberDetail";
import LeadersMemberCard from "@/components/fanClub/leaders/LeadersMemberCard";
import LeadersListHeader from "@/components/fanClub/leaders/LeadersListHeader";
import { mapGetters } from "vuex";

export default {
  components: {
    LeadersMemberCard,
    LeadersListHeader
  },

  computed: {
    ...mapGetters("leaders", ["headerImg"])
  },
  data() {
    return {
      contentId: "",
      categoryIconUrl: "",
      categoryName: "",
      content: "",
      memberName: "",
      prefecture: "",
      mainImageUrl: "",
      sub1ImageUrl: "",
      sub2ImageUrl: "",
      showCategoryIcon: false
    };
  },
  async created() {
    // URLから値を取得する
    this.contentId = this.$route.params.id;
    this.categoryName = this.$route.params.category;

    // memberの詳細情報を取得するAPI叩き、dataに格納する
    try {
      let res = await GetContent.getContent(this.contentId);
      this.contentId = res.id;
      this.categoryIconUrl = res.categoryIconUrl;
      this.content = res.content;
      this.memberName = res.memberName;
      this.prefecture = res.prefecture;
      this.mainImageUrl = res.mainImageUrl;
      this.sub1ImageUrl = res.sub1ImageUrl;
      this.sub2ImageUrl = res.sub2ImageUrl;
      this.showCategoryIcon = res.showCategoryIcon;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style lang="css" scoped>
.member-detail-body {
  background-image: url("~@/assets/images/fanclub/leaders/BG_leaders_1920.png");
  background-size: contain;
  width: 100%;
  height: 100%;
  padding: 150px 10% 10% 10%;
}
.member-name {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 5% 0;
}
.rank-img {
  height: 60px;
  width: auto;
}
.text-name {
  font-size: 120%;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-component {
  position: fixed;
  top: 0;
  left: 0;
}
.member-content {
  background-color: white;
  margin-bottom: 5%;
}
.html-content {
  padding: 5%;
}
.sub-img {
  padding-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/leaders/LeadersMemberDetail.vue